import { useState } from "react";
import { Award, Maximize2 } from "lucide-react";
import { CertificateLightbox } from "@/pages/gbt/CertificateLightbox";

const IMG = "/attestato-laser-diodo.webp";
const THUMB = "/attestato-laser-diodo-thumb.webp";
const ALT = "Attestato di partecipazione del Dott. Nicola Mauro al corso di formazione sull'utilizzo del laser a diodo in odontoiatria, Vicenza 26 settembre 2026";

export const LaserAttestato = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="laser-attestato-card"
        className="group mt-10 w-full max-w-xl flex flex-col sm:flex-row sm:items-center gap-5 rounded-3xl bg-[#FCFBF7] border border-[#1B3B28]/10 p-4 text-left hover:border-[#86C89B] hover:shadow-[0_20px_50px_-25px_rgba(27,59,40,0.4)] transition-[border-color,box-shadow]"
        aria-label="Ingrandisci l'attestato sul laser a diodo">
        <span className="relative block w-full sm:w-44 shrink-0 overflow-hidden rounded-2xl bg-white">
          <img src={THUMB} alt="Attestato laser a diodo" loading="lazy" className="w-full aspect-[10/7] object-cover transition-transform duration-700 group-hover:scale-105" />
          <span className="absolute bottom-2 right-2 grid place-items-center w-8 h-8 rounded-full bg-[#1B3B28] text-[#FCFBF7]"><Maximize2 size={13} /></span>
        </span>
        <span className="block px-1 sm:px-0">
          <span className="eyebrow text-[#3E6B48] inline-flex items-center gap-2"><Award size={13} /> Formazione</span>
          <span className="block f-serif text-2xl text-[#1B3B28] leading-tight mt-2">Laser a diodo in odontoiatria</span>
          <span className="block text-sm text-[#526356] mt-1.5 leading-snug">Attestato del corso di formazione · Master Class Academy · Vicenza, 26 settembre 2026</span>
          <span className="block text-sm text-[#3E6B48] mt-2 underline underline-offset-4 decoration-[#86C89B]/60">Guarda l'attestato</span>
        </span>
      </button>
      <CertificateLightbox open={open} onClose={() => setOpen(false)} src={IMG} alt={ALT} label="Attestato laser a diodo" tid="laser-attestato" />
    </>
  );
};
